
export default {
  name: 'SelectFilter',
  emits: ['onChangeFilterVariant'],

  data() {
    return {
      checkedValue: [],
    };
  },

  props: {
    filter: {
      type: Object,
      default() {
        return {};
      },
    },
    optionsList: {
      type: Object,
      default() {
        return {};
      },
    },
    selectedFilters: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    valuesLabel() {
      return [...this.checkedValue || []].map((t) => t?.label).join(', ');
    },

    options() {
      const available = this.filter?.available || [];
      return [...this.filter.variants].map((t) => ({
        ...t,
        $isDisabled: !available.includes(t.value),
      }));
    },
  },

  watch: {
    selectedFilters() {
      this.updateFilter();
    },
  },

  methods: {

    updateFilter() {
      if (this.selectedFilters && Object.keys(this.selectedFilters).length) {
        Object.keys(this.selectedFilters?.[this.optionsList?.slug] || {}).forEach((t) => {
          if ((this.checkedValue || []).find((val) => val?.slug === t)) {
            return null;
          }

          this.checkedValue.push(this.optionsList.variants.find((variant) => variant?.slug === t));
        });
      } else {
        this.checkedValue = [];
      }
    },

    isSelected(slug) {
      return Boolean(
        (this.checkedValue || []).find(
          (t) => t.slug === slug,
        ),
      );
    },
    isDisabled(slug) {
      const available = this.filter?.available || [];
      return !available.includes(slug);
    },

    onEmitValue() {
      this.$emit('onChangeFilterVariant', this.optionsList.slug, this.getVariantSlug());
    },

    getVariantSlug() {
      const checkedValue = [...this.checkedValue];
      const slug = {};

      checkedValue.forEach((t) => {
        if (t.slug) {
          slug[t.slug] = t.slug;
        }
      });

      if (Object.keys(slug).length <= 0) {
        return null;
      }

      return slug;
    },
  },

  mounted() {
    this.updateFilter();
  },
};
